import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { creditCardService } from '../services/creditCardService'
import { cardKeys } from './cards'

export const referralKeys = {
  all: ['referral-links'] as const,
}

/** Wraps getAllCards — re-uses the shared cards cache. */
export function useCardsForReferrals() {
  return useQuery({
    queryKey: cardKeys.lists(),
    queryFn:  () => creditCardService.getAllCards(),
  })
}

export function useUpdateReferralLink() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ cardId, referralUrl, notes }: { cardId: string; referralUrl: string; notes?: string }) =>
      creditCardService.updateReferralLink(cardId, referralUrl, notes, 'admin'),
    onSuccess: () => { qc.invalidateQueries({ queryKey: cardKeys.all }) },
  })
}

export function useRemoveReferralLink() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (cardId: string) => creditCardService.removeReferralLink(cardId),
    onSuccess: () => { qc.invalidateQueries({ queryKey: cardKeys.all }) },
  })
}
